










































































































































































import { BaseRequisitesVue } from "fs-pb-vue2/vueModels/contracts/BaseRequisitesVue";
import DetailsList from "fs-pb-vue2/components/DetailsList.vue";
import BackLink from "@/components/app/BackLink.vue";
import { Component, Prop } from "vue-property-decorator";
import Preloader from "@/components/app/Preloader.vue";
import i18n from "@/i18n";

@Component({
  components: { DetailsList, BackLink, Preloader }
})
export default class Requisites extends BaseRequisitesVue {

  @Prop() subtitle!: string;

  async mounted() {
    await this.init();
  }

  /** реквизиты счета */
  get details(): Array<any> {
    let bankDetails: Array<any> = [];
    if (this.bankDetails) {
      bankDetails = [
        {
          //Владелец Счета
          name: i18n.t("main.contracts.bankDetails.RecepientName"),
          isWrapped: true,
          textVal: this.bankDetails.RecepientName
        },
        {
          //Расчётный/Лицевой счёт
          name: i18n.t("main.contracts.bankDetails.Rs"),
          textVal: this.bankDetails.Rs
        },
        {
          //Банк получателя"
          name: i18n.t("main.contracts.bankDetails.BankName"),
          textVal: this.bankDetails.BankName
        },
        {
          //БИК
          name: i18n.t("main.contracts.bankDetails.Bik"),
          textVal: this.bankDetails.Bik
        },
        {
          //Корр. счёт
          name: i18n.t("main.contracts.bankDetails.Ks"),
          isWrapped: true,
          textVal: this.bankDetails.Ks
        },
        {
          //ИНН
          name: i18n.t("main.contracts.bankDetails.Inn"),
          textVal: this.bankDetails.Inn
        }
        // {
        //   name: i18n.t("main.contracts.bankDetails.Info"),
        //   isWrapped: true,
        //   textVal: this.bankDetails.Info
        // }
      ];
    }
    return bankDetails;
  }

  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

  async shareRequisites(): Promise<void> {
    if (this.isMobileBrowser) {
      try {
        const shareData = {
          title: "Реквизиты",
          text: this.detailsToString()
        };
        await navigator.share(shareData).catch(() => { this.emailFormIsOpen = !this.emailFormIsOpen; });
      } catch (e) {
        this.emailFormIsOpen = !this.emailFormIsOpen;
      }
    } else {
      this.emailFormIsOpen = !this.emailFormIsOpen;
    }
  }

  async sendEmailExt(): Promise<void> {
    if (this.isMobileBrowser) {
      if (!this.messageTarget) this.testEmail();
      if (this.isEmailValid || this.messageTarget) {
        window.location.href = `mailto:${this.emailValue}?subject=Реквизиты&body=${this.detailsToString()}`;
      }
    } else {
      await this.sendEmail();
    }

  }

  detailsToString(): string {
    let sDetails: string = "";
    this.details.forEach(d => {
      sDetails += `${d.name} ${d.textVal}\r\n`;
    });
    return sDetails;
  }
}
